import React from 'react';
import './HowWeHelp.css';
import background from '../../Assets/background_images/background3.png';


function LeadershipIdentification() {
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <img className='image' src={background} alt='hiring' />
        <div className='heading'> Leadership Identification </div>
      </div>

      <div>
        <h1 className='title'>Leadership Identification – spot & support your rising stars</h1>
        <p className='paragraph'>How do you measure the potential? How do you keep today's leaders and involve tomorrow's leaders  so they grow in your company? We have the  tools and insights to identify the executive you are looking for. </p>

        <ul className='outer-list'>
          <li>Building a team with strong  leadership skills is important at all levels of the organization, from team leaders to C Suite.  </li>
          <li>Whether you lead a project, process, or person, your leadership style is predictable. Choosing the person with the best personality can affect or destroy culture and profitability. </li>
          <li>Increase engagement and loyalty by  keeping  the right people at the top.</li>
        </ul>
      </div>
      <hr />

      <div>
        <h1 className='title'> How Strategic Links can help: </h1>

        <ul className='outer-list'>
          <li>Leadership is not a panacea. Depending on the needs of your company and your team, you will deserve the best leader for you. We consider aspects such as superiority and performance orientation in the security world, business reasoning, conflict management, open communication and leadership. Leadership is not a panacea. Depending on the needs of your company and your team, you will deserve the best leader for you. We consider aspects such as superiority and performance orientation in the security world, business reasoning, conflict management, open communication and leadership. </li>
          <li>The report contains individual interview and development questions to help you investigate and guide your personal strengths and potential problem areas. </li>
          <li>Better insights help you make better decisions. It is advisable to weigh the assessment results as part of the attitude, along with experience,  background checks, background checks, and interview impressions.</li>
          <li>Look beyond Person-Job-Fit to Person-Organization-Fit. Identify leaders who have work values ​​and attitudes that fit your culture and can build a strong and successful team.</li>
        </ul>
      </div>
    </div>
  );
}

export default LeadershipIdentification;
